<script setup lang="ts">
const localePath = useLocalePath()
const { t } = useI18n()

defineI18nRoute({
  paths: {
    'en-CA': '/sitemap',
    'fr-CA': '/sitemap'
  }
})

useHead({
  title: t('navigation.sitemap.metatitle'),
  meta: [{ name: 'description', content: t('navigation.sitemap.metadescription') }],
})

</script>

<template>
  <div class="wrapContent">
    <div class="entetePage">
      <div class="wrapper">
        <div class="filAriane">
          <span class="">
            <NuxtLink :to="localePath('index')">{{ $t('navigation.home.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <span class="">{{ $t('navigation.sitemap.name') }}</span>
          </span>
        </div>
        <div class="title">
          <h1><span class="">{{ $t('navigation.sitemap.name') }}</span></h1>
        </div>
      </div>
    </div>
    <div class="contentPage">
      <div class="wrapper clearfix">
        <MenuSitemap />
        <div class="contenu right">
          <div class="menuCss8">
            <ul>
              <li class="item6 first rank0">
                <NuxtLink :to="localePath('index')">{{ $t('navigation.home.name') }}</NuxtLink>
              </li>
              <li class="item29 rank1 parent">
                <NuxtLink :to="localePath('about-about')">{{ $t('navigation.about.name') }}</NuxtLink>
                <div class="itemChildDiv29">
                  <ul class="itemChild29">
                    <li class="item14 first rank0">
                      <NuxtLink :to="localePath('about-corporateProfile')">{{ $t('navigation.corporateProfile.name') }}</NuxtLink>
                    </li>
                    <li class="item15 rank1">
                      <NuxtLink :to="localePath('about-management')">{{ $t('navigation.management.name') }}</NuxtLink>
                    </li>
                    <li class="item12 rank2">
                      <NuxtLink :to="localePath('about-boardDirectors')">{{ $t('navigation.boardDirectors.name') }}</NuxtLink>
                    </li>
                    <li class="item18 last rank3">
                      <NuxtLink :to="localePath('about-facilities')">{{ $t('navigation.facilities.name') }}</NuxtLink>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="item9 rank2 parent">
                <NuxtLink :to="localePath('products')">{{ $t('navigation.products.name') }}</NuxtLink>
                <div class="itemChildDiv9">
                  <ul class="itemChild9">
                    <li class="item22 first rank0">
                      <NuxtLink :to="localePath('products-consumerMarket')">{{ $t('navigation.consumerMarket.name') }}</NuxtLink>
                    </li>
                    <li class="item17 rank1"
                        id="c79_1_1">
                      <NuxtLink :to="localePath('products-awayFromHomeMarket')">{{ $t('navigation.awayFromHomeMarket.name') }}</NuxtLink>
                    </li>
                    <li class="item19 last rank2"
                        id="c79_1_2">
                      <NuxtLink :to="localePath('products-privateLabelMarket')">{{ $t('navigation.privateLabelMarket.name') }}</NuxtLink>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="item20 rank3 parent">
                <NuxtLink :to="localePath('newsEvents')">{{ $t('navigation.newsEvents.name') }}</NuxtLink>
                <div class="itemChildDiv20">
                  <ul class="itemChild20">
                    <li class="item21 first rank0">
                      <NuxtLink :to="localePath('pressReleases')">{{ $t('navigation.pressReleases.name') }}</NuxtLink>
                    </li>
                    <li class="item54 last rank1">
                      <NuxtLink :to="localePath('presentationsWebcasts')">{{ $t('navigation.presentationsWebcasts.name') }}</NuxtLink>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="item30 rank4 parent">
                <NuxtLink :to="localePath('investorRelations-investorRelations')">{{ $t('navigation.investorRelations.name') }}</NuxtLink>
                <div class="itemChildDiv30">
                  <ul class="itemChild30">
                    <li class="item31 first rank0 parent">
                      <NuxtLink :to="localePath('investorRelations-financialDocuments-quarterlyReports')">{{ $t('navigation.financialDocuments.name') }}</NuxtLink>
                      <div class="itemChildDiv31">
                        <ul class="itemChild31">
                          <li class="item11 first rank0">
                            <NuxtLink :to="localePath('investorRelations-financialDocuments-quarterlyReports')">{{ $t('navigation.quarterlyReports.name') }}</NuxtLink>
                          </li>
                          <li class="item32 rank1">
                            <NuxtLink :to="localePath('investorRelations-financialDocuments-annualReports')">{{ $t('navigation.annualReports.name') }}</NuxtLink>
                          </li>
                          <li class="item52 rank2">
                            <NuxtLink :to="localePath('investorRelations-financialDocuments-presentationsWebcasts')">{{ $t('navigation.presentationsWebcasts.name') }}</NuxtLink>
                          </li>
                          <li class="item33 rank3">
                            <NuxtLink :to="localePath('investorRelations-financialDocuments-managementProxyCirculars')">{{ $t('navigation.managementProxyCirculars.name') }}</NuxtLink>
                          </li>
                          <li class="item34 last rank4">
                            <NuxtLink :to="localePath('investorRelations-financialDocuments-annualInformationForms')">{{ $t('navigation.annualInformationForms.name') }}</NuxtLink>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li class="item36 rank1 parent">
                      <NuxtLink :to="localePath('investorRelations-shareholderInformation')">{{ $t('navigation.shareholderInformation.name') }}</NuxtLink>
                      <div class="itemChildDiv36">
                        <ul class="itemChild36">
                          <li class="item60 first rank0">
                            <NuxtLink :to="localePath('investorRelations-stockChart')">{{ $t('navigation.stockChart.name') }}</NuxtLink>
                          </li>
                          <li class="item37 rank1">
                            <NuxtLink :to="localePath('investorRelations-dividendDripPolicies')">{{ $t('navigation.dividendDripPolicies.name') }}</NuxtLink>
                          </li>
                          <li class="item38 rank2">
                            <NuxtLink :to="localePath('investorRelations-transfertAgentAuditor')">{{ $t('navigation.transfertAgentAuditor.name') }}</NuxtLink>
                          </li>
                          <li class="item39 rank3">
                            <NuxtLink :to="localePath('investorRelations-faq')">{{ $t('navigation.faq.name') }}</NuxtLink>
                          </li>
                          <li class="item40 last rank4">
                            <NuxtLink :to="localePath('investorRelations-irContact')">{{ $t('navigation.irContact.name') }}</NuxtLink>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li class="item42 rank2 parent">
                      <NuxtLink :to="localePath('investorRelations-corporateGovernance')">{{ $t('navigation.corporateGovernance.name') }}</NuxtLink>
                      <div class="itemChildDiv42">
                        <ul class="itemChild42">
                          <li class="item71 first last rank0">
                            <NuxtLink :to="localePath('investorRelations-governanceCommitteeCharter')">{{ $t('navigation.governanceCommitteeCharter.name') }}</NuxtLink>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li class="item58 last rank3">
                      <NuxtLink :to="localePath('investorRelations-emailAlerts')">{{ $t('navigation.emailAlerts.name') }}</NuxtLink>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="item55 rank5 parent">
                <NuxtLink :to="localePath('sustainability-sustainableDevelopment')">{{ $t('navigation.sustainability.name') }}</NuxtLink>
                <div class="itemChildDiv55">
                  <ul class="itemChild55">
                    <li class="item45 first last rank0">
                      <NuxtLink :to="localePath('sustainability-sustainableDevelopment')">{{ $t('navigation.sustainableDevelopment.name') }}</NuxtLink>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="item46 rank6">
                <NuxtLink :to="localePath('contact')">{{ $t('navigation.contact.name') }}</NuxtLink>
              </li>
              <li class="item16 last rank7">
                <NuxtLink :to="localePath('termsConditions')">{{ $t('navigation.termsConditions.name') }}</NuxtLink>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
